/**
 * Generic error handler for API responses
 * Extracts meaningful error messages from various error response formats
 * @param {Error} err - The error object from axios or other sources
 * @param {string} defaultMessage - Default error message if specific message cannot be extracted
 * @returns {string} - Formatted error message for display to user
 */
export const extractErrorMessage = (
   err,
   defaultMessage = "An error occurred. Please try again."
) => {
   let errorMessage = defaultMessage;

   if (err.response && err.response.data) {
      // Check for detail field (FastAPI error format)
      if (err.response.data.detail) {
         // Handle FastAPI validation errors (array of error objects)
         if (Array.isArray(err.response.data.detail)) {
            const errorMessages = err.response.data.detail.map((error) => {
               if (error.msg) {
                  return error.msg;
               } else if (typeof error === "string") {
                  return error;
               } else {
                  return JSON.stringify(error);
               }
            });
            errorMessage = errorMessages.join(". ");
         } else if (typeof err.response.data.detail === "string") {
            errorMessage = err.response.data.detail;
         } else {
            errorMessage = JSON.stringify(err.response.data.detail);
         }
      }
      // Check for error field (custom API error format)
      else if (err.response.data.error) {
         errorMessage = err.response.data.error;
      }
      // Check for message field
      else if (err.response.data.message) {
         errorMessage = err.response.data.message;
      }
   }
   // Check if it's a network error
   else if (err.message && err.message.includes("Network Error")) {
      errorMessage = "Network error. Please check your connection and try again.";
   }
   // Check for other axios error messages
   else if (err.message) {
      errorMessage = err.message;
   }

   return errorMessage;
};

/**
 * Extracts the "detail" field from axios error response
 * @param {Error} axiosError - The axios error object
 * @returns {string|null} - The detail message or null if not found
 */
export const extractDetailFromError = (axiosError) => {
   return axiosError?.response?.data?.detail || null;
};
